import { AnchorHTMLAttributes, ImgHTMLAttributes } from 'react';

interface Member extends AnchorHTMLAttributes<HTMLAnchorElement> {
  imageProps: ImgHTMLAttributes<HTMLImageElement>;
}

interface Members {
  members: Member[];
  label: string;
}

export const memberData: Members[] = [
  {
    label: 'Our Member',
    members: [
      {
        imageProps: {
          src: `${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/logos/our/dalock.png`,
          alt: '다락 로고',
        },
        href: 'http://www.dalock.kr/',
        target: '_blank',
      },
      {
        imageProps: {
          src: `${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/logos/our/oho.png`,
          alt: '오호스페이스 로고',
        },
        href: 'http://www.oho.co.kr/',
        target: '_blank',
      },
      {
        imageProps: {
          src: `${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/logos/our/iambox.png`,
          alt: '아이엠박스 로고',
        },
        href: 'http://iambox.co.kr/',
        target: '_blank',
      },
      {
        imageProps: {
          src: `${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/logos/our/modoo.png`,
          alt: '작은창고 로고',
        },
        href: 'https://smallstoragegwanggyo.modoo.at/',
        target: '_blank',
      },
      {
        imageProps: {
          alt: '메타코리아 로고',
          src: `${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/logos/our/matakorea.png`,
        },
        href: 'https://www.instagram.com/mata_korea/',
        target: '_blank',
      },
      {
        imageProps: {
          src: `${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/logos/our/selfstorage.png`,
          alt: '셀프스토리지 로고',
        },
        href: undefined,
        target: '_blank',
      },
      {
        imageProps: {
          alt: '나의창고 로고',
          src: `${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/logos/our/mystorage.png`,
        },
        href: 'https://pf.kakao.com/_xlxjwzxj',
        target: '_blank',
      },
      {
        imageProps: {
          alt: '공유창고 미니멀 로고',
          src: `${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/logos/our/minimal.png`,
        },
        href: 'https://jjminimal.modoo.at/',
        target: '_blank',
      },
      {
        imageProps: {
          alt: '공간플러스 로고',
          src: `${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/logos/our/gongganplus.png`,
        },
        href: 'https://gonggan1.w3ur.com/',
        target: '_blank',
      },
      {
        imageProps: {
          alt: '도심창고 곳간 로고',
          src: `${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/logos/our/kokkan.png`,
        },
        href: 'https://www.kokkan.co.kr/',
        target: '_blank',
      },
      {
        imageProps: {
          alt: '공유창고 알파룸 로고',
          src: `${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/logos/our/alpharoom.png`,
        },
        href: 'https://m.blog.naver.com/dachae-co',
        target: '_blank',
      },
    ],
  },
  {
    label: 'Special Member',
    members: [
      {
        imageProps: {
          alt: '법무법인 대륙아주 로고',
          src: `${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/logos/special/draju.png`,
        },
        href: 'https://www.draju.com',
        target: '_blank',
      },
      {
        imageProps: {
          alt: '최앤리 법률사무소 로고',
          src: `${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/logos/special/choilee.png`,
        },
        href: 'http://choilee-law.com/',
        target: '_blank',
      },
    ],
  },
  {
    label: 'Our Partner',
    members: [
      {
        imageProps: {
          alt: 'KT에스테이트 로고',
          src: `${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/logos/partner/ktestate.png`,
        },
        href: 'https://www.ktestate.com/index.asp',
        target: '_blank',
      },
      {
        imageProps: {
          alt: '에스원 로고',
          src: `${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/logos/partner/s1.png`,
        },
        href: 'https://www.s1.co.kr/',
        target: '_blank',
      },
      {
        imageProps: {
          alt: 'ADT캡스 로고',
          src: `${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/logos/partner/adtcaps.png`,
        },
        href: 'https://www.skshieldus.com/',
        target: '_blank',
      },
      {
        imageProps: {
          alt: 'KT텔레캅 로고',
          src: `${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/logos/partner/kttelecop.png`,
        },
        href: 'https://www.kttelecop.co.kr',
        target: '_blank',
      },
      {
        imageProps: {
          alt: '블루몬 로고',
          src: `${process.env.NEXT_PUBLIC_CLOUD_FRONT}/partners/ssak/membership/logos/partner/bluemon.png`,
        },
        href: undefined,
        target: '_blank',
      },
    ],
  },
];
